import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

/* =========================================
   🌐 API BASE
========================================= */
const API = process.env.REACT_APP_API_URL;

export default function MiBoletin() {
  const { token, user } = useAuth();

  const [periodoId, setPeriodoId] = useState('');
  const [boletin, setBoletin] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  /* =========================================
     🔐 VALIDACIÓN INICIAL
  ========================================= */
  useEffect(() => {
    if (!API) {
      setError('REACT_APP_API_URL no está configurado');
    }
  }, []);

  /* =========================================
     📄 CARGAR BOLETÍN
  ========================================= */
  const cargar = async () => {
    setError('');

    if (!periodoId) {
      return setError('Debe ingresar el periodo');
    }

    if (!user?.matricula_id) {
      return setError('Usuario sin matrícula asociada');
    }

    try {
      setLoading(true);

      const res = await axios.get(
        `${API}/api/boletin/${user.matricula_id}/${periodoId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          timeout: 15000
        }
      );

      setBoletin(res.data);

    } catch (err) {
      if (err.response?.status === 403) {
        setError('No autorizado para ver este boletín');
      } else if (err.response?.status === 404) {
        setError('Boletín no encontrado');
      } else {
        setError('Error conectando con el servidor');
      }
    } finally {
      setLoading(false);
    }
  };

  /* =========================================
     🖥️ UI
  ========================================= */
  return (
    <div className="panel">
      <h2>📄 Mi Boletín</h2>

      {error && (
        <div className="error-box">
          ⚠️ {error}
        </div>
      )}

      <div className="form">
        <input
          type="number"
          placeholder="Periodo ID"
          value={periodoId}
          onChange={e => setPeriodoId(e.target.value)}
          disabled={loading}
        />

        <button onClick={cargar} disabled={loading}>
          {loading ? '⏳ Cargando...' : '📘 Ver Boletín'}
        </button>
      </div>

      {boletin && (
        <div className="card">
          <h3>
            {boletin.estudiante.nombres} {boletin.estudiante.apellidos}
          </h3>

          <p>
            <strong>Promedio:</strong> {boletin.promedio}
          </p>

          <p>
            <strong>Desempeño:</strong> {boletin.desempeno_final}
          </p>

          <table>
            <thead>
              <tr>
                <th>Materia</th>
                <th>Nota</th>
                <th>Desempeño</th>
              </tr>
            </thead>
            <tbody>
              {boletin.materias.map(m => (
                <tr key={m.materia_id}>
                  <td>{m.materia}</td>
                  <td>{m.nota}</td>
                  <td>{m.desempeno}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
